import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import Group from "@midland-industries/Components/Group";
import Stack from "@midland-industries/Components/Stack";
import { colors } from "@midland-industries/Styles/colors";
import React from "react";
import styled from "styled-components";

const TrustedImg = styled.div`
    width: 463px;
    height: 513px;
    aspect-ratio: cos(30deg);
    clip-path: polygon(-50% 50%, 50% 100%, 150% 50%, 50% 0);
    background-image: url("/staticContent/trusted.png");
    background-size: cover;
`;

const Trusted: React.FC = () => {
    return (
        <Group
            gap={90}
            style={{ padding: "60px 30px 60px 30px", backgroundColor: colors.background }}
            justify="center"
            align="center"
        >
            <Stack>
                <TrustedImg />
            </Stack>
            <Stack gap={15} style={{ width: 476 }}>
                <Typography color={colors.textAccent} size={24} lineHeight="24px" transform="uppercase">
                    trusted for decades
                </Typography>
                <Typography color={colors.textMain} size={40} weight={700} lineHeight="48px">
                    Talk to an expert who knows your projects inside-out
                </Typography>
                <Typography lineHeight="24px" color={colors.textAccent}>
                    We’re here to help, and are proud of our reputation for service. Whether you need help selecting the
                    right item, or are looking to meet a complex order on a tight deadline, get in touch and we’ll be
                    happy to assist.
                </Typography>
                <Link href="/Contact">Contact Us</Link>
            </Stack>
        </Group>
    );
};

export default Trusted;
